var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[_c('slide-y-up-transition',{attrs:{"mode":"out-in","origin":"center top"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }